import React from 'react';
import { useIntl } from 'react-intl';

import Button, {
  ButtonShape,
  ButtonSize,
  ButtonVariants,
} from '@/components/switchback/Button/Button';
import { SHARE } from '@/components/switchback/Icon/assets';
import Icon, { IconSize } from '@/components/switchback/Icon/IconComponent';

interface IShareButtonProps {
  onClick?: () => void;
  shape?: ButtonShape;
  size?: ButtonSize;
  variant?: ButtonVariants;
  hideLabel?: boolean;
}
const ShareButton: React.FC<IShareButtonProps> = ({
  onClick,
  shape = ButtonShape.pill,
  size = ButtonSize.xsmall,
  variant = ButtonVariants.whiteContained,
  hideLabel = false,
}) => {
  const intl = useIntl();

  return (
    <Button
      data-testid="listing-share-btn"
      variant={variant}
      size={size}
      shape={shape}
      className="pointer-events-auto"
      onClick={onClick}>
      <Icon name={SHARE} size={IconSize.large} />
      {!hideLabel && (
        <span className="hidden underline md:inline">
          {intl.formatMessage({
            defaultMessage: 'Share',
            id: 'OKhRC6',
          })}
        </span>
      )}
    </Button>
  );
};

export default ShareButton;
